<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('resellers.add_group')"
  :rightActions="rightActions"
)
  UiFormGroup(:label="$t('resellers.name')") 
    UiInput(v-model="form.name")

  UiFormGroup(label="Choose companies:")
    UiStack(
      vertical
      spacing="xs"
    )
      UiCheckbox(
        :key="company.id"
        :modelValue="isSelectedCompany(company.id)"
        @update:modelValue="toggleCompany(company.id)"
        v-for="company in resellerCompanies"
        switch
      ) {{ company.company_name }}{{ company.company_group_name != null ? " (group " + company.company_group_name + ")" : "" }}
</template>

<script>
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      show: false,
      isAdd: false,
      resellerId: null,
      form: {},
      resellerCompanies: [],
      selected: [],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.save"),
          icon: "Check",
          onClick: this.save,
        },
      ];
    },
  },

  methods: {
    fetchResellerCompanies() {
      return new Promise((res) => {
        ApiResellers.fetchResellerCompanies(this.$route.params.id).then(
          (resp) => {
            this.resellerCompanies = resp.data.reseller_companies;
            this.selected = resp.data.reseller_companies
              .filter(
                (company) =>
                  company["company_group_id"] == this.form.id &&
                  company["company_group_id"] !== null,
              )
              .map((h) => h["id"]);
          },
        );
      });
    },

    open(resellerId, resellerCompanyGroup) {
      this.fetchResellerCompanies();
      if (resellerCompanyGroup) {
        this.isAdd = false;
        this.form = {
          id: resellerCompanyGroup.id,
          name: resellerCompanyGroup.name,
        };
      } else {
        this.isAdd = true;
        this.form = {
          name: "",
        };
      }
      this.resellerId = resellerId;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    save() {
      const form = this.form;
      const params = {
        name: form.name,
        company_ids: this.selected,
      };
      const resellerId = this.resellerId;
      if (this.isAdd) {
        ApiResellers.addResellerCompanyGroup(resellerId, params)
          .then((res) => {
            this.$emit("done");
            this.close();
          })
          .catch((e) => {});
      } else {
        ApiResellers.updateResellerCompanyGroup(resellerId, form.id, params)
          .then((res) => {
            this.$emit("done");
            this.close();
          })
          .catch((e) => {});
      }
    },

    isSelectedCompany(id) {
      return this.selected.indexOf(id) >= 0;
    },

    toggleCompany(id) {
      const index = this.selected.indexOf(id);
      if (index >= 0) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }
    },
  },
};
</script>
